import { first, last } from "lodash-es";
import moment from "moment-timezone";
import { useEffect, useMemo } from "react";
import { useSchedulerStore } from "../state/scheduler.store";

export const useAutobookDatePicker = () => {
  const { sessionData } = useSchedulerStore();

  const { minDate, maxDate } = useMemo(() => {
    const minDate = moment(first(sessionData?.computedAvailability)?.date)
      .tz(sessionData?.selectedTimezone ?? moment.tz.guess())
      .format("YYYY-MM-DD");

    const maxDate = moment(last(sessionData?.computedAvailability)?.date)
      .tz(sessionData?.selectedTimezone ?? moment.tz.guess())
      .format("YYYY-MM-DD");

    return { minDate, maxDate };
  }, [sessionData]);

  const { allDates, utcAdjustedAllDates } = useMemo(() => {
    const allDates =
      sessionData?.computedAvailability?.map((slot) => {
        return moment(slot.date)
          .tz(sessionData?.selectedTimezone ?? moment.tz.guess())
          .format("YYYY-MM-DD");
      }) ?? [];

    const utcAdjustedAllDates = allDates.map((date) => {
      return moment(date).tz("UTC", true).startOf("day").format();
    });

    return { allDates, utcAdjustedAllDates };
  }, [sessionData?.computedAvailability, sessionData?.selectedTimezone]);

  const selectedDate = useMemo(() => {
    const selected = sessionData?.selectedSlot?.date;

    if (
      selected &&
      moment(selected).isSameOrAfter(minDate) &&
      moment(selected).isSameOrBefore(maxDate)
    ) {
      return selected;
    }

    return moment(minDate).valueOf();
  }, [sessionData?.selectedSlot, sessionData?.computedAvailability, minDate]);

  return { minDate, maxDate, selectedDate, allDates, utcAdjustedAllDates };
};
